export default {
  markup: 0,
  heights: [1000, 1200, 1450, 1600, 1750, 1950],
  items: [
    { muster: 'AW.10.01', prices: { 1000: 112, 1200: 127, 1450: 144, 1600: 154, 1750: 165, 1950: 180 } },
    { muster: 'AW.10.02', prices: { 1000: 111, 1200: 125, 1450: 142, 1600: 152, 1750: 161 } },
    { muster: 'AW.10.04', prices: { 1000: 87, 1200: 96, 1450: 106, 1600: 113, 1750: 118, 1950: 127 } },
    { muster: 'AW.10.05', prices: { 1000: 98, 1200: 110, 1450: 124, 1600: 132, 1750: 141 } },
    { muster: 'AW.10.06', prices: { 1000: 95, 1200: 104, 1450: 116, 1600: 123, 1750: 128, 1950: 139 } },
    { muster: 'AW.10.16', prices: { 1000: 158, 1200: 178, 1450: 204, 1600: 219, 1750: 235, 1950: 256 } },
    { muster: 'AW.10.17', prices: { 1000: 129, 1200: 145, 1450: 164, 1600: 178, 1750: 189, 1950: 206 } },
    { muster: 'AW.VA.55', prices: { 1000: 157, 1200: 170, 1450: 173, 1600: 187, 1750: 189, 1950: 198 } },
    { muster: 'AW.10.70', prices: { 1000: 133, 1200: 145, 1450: 161, 1600: 170 } },
    { muster: 'AW.10.71', prices: { 1000: 123, 1200: 134, 1450: 147 } },
    { muster: 'AW.10.72', prices: { 1000: 159, 1200: 176, 1450: 197, 1600: 209 } },
    { muster: 'AW.10.TT', prices: { 1000: 164, 1200: 184, 1450: 210, 1600: 224, 1750: 240, 1950: 261 } },
    { muster: 'AW.10.76', prices: { 1000: 240, 1200: 273, 1450: 308, 1600: 331, 1750: 354, 1950: 385 } },
    { muster: 'AW.10.78', prices: { 1000: 235, 1200: 268, 1450: 302, 1600: 324, 1750: 347, 1950: 378 } }
  ]
}
